// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// import { version } from '../../package.json';
import pkg from "../../package.json";

export const environment = {
  production: false,
  environmentName: "test",
  version: pkg.version,
  urlServices:
    'https://rogoproxy.xyz/http://microsqa.gruporoga.com:2023/rogaservices',

  loginRoga:
    "https://rogoproxy.xyz/http://ms.gruporoga.com:2026/security/login",
  userRoga: {
    userId: 6972,
    userPass: 3601285,
    userProfile: 1,
    macAddress: "00-14-22-01-23-45",
    appId: 19,
    idSucursal: 1,
    appVersion: pkg.version,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
